import { render, staticRenderFns } from "./OccupancyReports.vue?vue&type=template&id=1881b01e&"
import script from "./OccupancyReports.vue?vue&type=script&lang=ts&"
export * from "./OccupancyReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports